import axios from "axios";
import config from "./config";

const signUp = (
  firstName,
  lastName,
  email,
  password,
  redirectTo,
  setSignUp
) => {
  var rc = window.grecaptcha;
  var rcKey = window.UI8.recaptchaSiteKey;
  if (!rc || !rcKey) {
    return setSignUp({ error: "Unable to process registration" });
  }

  rc.execute(rcKey, { action: "registration" }).then((token) => {
    axios
      .post(`${config.LOGIN_SERVER_URL}/account/register?json=1`, {
        first_name: firstName,
        last_name: lastName,
        email,
        password,
        redirectTo,
        rcToken: token,
      })
      .then((response) => {
        setSignUp({
          error: response.data.error,
          status: "success",
        });
      })
      .catch(() => {
        setSignUp({ error: "Unable to process registration" });
      });
  });
};

export default signUp;
